import { FC } from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import { RefinementListProvided } from "react-instantsearch-core";
import { Box, Flex } from "@otrium/core";
import { Checkbox } from "src/atoms/Checkbox";
import {
  FilterMultiColumn,
  Wrapper,
} from "src/organisms/AlgoliaProductList/MobileFilterView/MobileFilters.styled";

const CustomRefinementList: FC<RefinementListProvided> = ({
  items,
  refine,
}) => {
  return (
    <Wrapper>
      <Flex
        p={1}
        height="100%"
        flexDirection="column"
        justifyContent="space-between"
        overflow="auto"
        flex="1 1 0%"
      >
        <FilterMultiColumn
          isMultiColumn={items && items.length > 1}
          count={Math.round(items.length / 2)}
        >
          {items.map((item) => {
            const label = item.label.split("||");
            const labelName = label[1];
            return (
              <Box as="li" key={labelName} pb={2}>
                <Checkbox
                  checked={item.isRefined}
                  onChange={() => {
                    refine(item.value);
                  }}
                >
                  {labelName}
                </Checkbox>
              </Box>
            );
          })}
        </FilterMultiColumn>
      </Flex>
    </Wrapper>
  );
};

const DefaultFilter = connectRefinementList(CustomRefinementList);

export default DefaultFilter;
